<template>
<div
	ref="modalRef"
	class="modal fade"
	tabindex="-1"
	aria-labelledby="modal-label"
	aria-hidden="true"
	data-bs-keyboard="false"
	data-bs-backdrop="static"
	v-on:keydown.esc.stop="close(0, 'reject')"
>
	<div
		class="modal modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-lg-down"
		:class="[size,]" ref="modalWindow"
	>
		<div class="modal-content px-0">
			<div class="modal-header" :class="[titleStyle,]">
				<svg
					v-if="showDescription !== null"
					xmlns="http://www.w3.org/2000/svg"
					width="20"
					height="20"
					fill="currentColor"
					class="bi bi-question-lg header-button"
					viewBox="0 0 16 16"
					@click="$emit('update:showDescription', !showDescription)"
				>
					<path fill-rule="evenodd" d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"/>
				</svg>
				<h1
					class="modal-title fs-5"
					:class="{'ms-2': showDescription !== null}"
				>
					<span v-if="title">{{ title }}</span>
				</h1>
				<button
					type="button"
					class="btn-close"
					aria-label="Close"
					@click="close(0, 'reject')"
				>
				</button>
			</div>

			<div class="modal-body overflow-x-hidden">
				<slot name="body">
				</slot>
			</div>

			<div
				v-if="isConfirmButton || isRejectButton"
				class="modal-footer"
			>
				<slot name="footer">
					<button
						v-if="isRejectButton"
						type="button"
						class="btn btn-secondary w-25"
						:class="{'me-5': isConfirmButton}"
						@click="onCancel()"
					>
						{{ rejectButtonTitle }}
					</button>
					<button
						v-if="isConfirmButton"
						type="button"
						class="btn btn-primary w-25"
						@click="onConfirm()"
					>
						{{ confirmButtonTitle }}
					</button>
				</slot>
			</div>
		</div>
	</div>
</div>
</template>




<script>
import { Modal } from "bootstrap"
import { nextTick } from "vue"


export default {
	props: {
		// Popup state
		show: {
			type: Boolean,
			required: true,
			default: false
		},

		// Question sign button
		// If null - hide button
		showDescription: {
			type: [Boolean, null],
			required: false,
			default: null,
		},

		titleStyle: {
			type: String,
			required: false,
			default: "",
		},

		title: {
			type: String,
			required: false,
			default: "",
		},

		confirmButtonTitle: {
			type: String,
			required: false,
			default: "",
		},

		rejectButtonTitle: {
			type: String,
			required: false,
			default: "",
		},

		// modal-sm, modal-lg, modal-xl
		size: {
			type: String,
			required: true,
			default: ''
		}
	},

	emits: [
		'update:show', // popup state feedback
		'update:showDescription', // description state feedback
		'confirm',
		'reject',
	],

	data() {
		return {
			// modal component object
			modal: null,
			handleHidePrevented: null,
		}
	},

	created() {},

	mounted() {
		nextTick(() => {
			// Show / hide popup if show property change
			this.$watch(() => this.show, (newVal) => {
				if (newVal) {
					// Show modal popup
					this.modal.show()
				} else {
					// Hide modal popup
					this.modal.hide()
				}
			})

			// Get modal object
			this.modal = new Modal(this.$refs.modalRef)

			this.handleHidePrevented = () => {
				this.close(0, "reject")
			}

			//console.log("Created popup", this.modal)
			if (this.modal) {
				// This event is fired when the modal is shown, its backdrop is static
				// and a click outside of the modal is performed. The event is also
				// fired when the escape key is pressed and the keyboard option is set to false.
				this.$refs.modalRef.addEventListener('hidePrevented.bs.modal', this.handleHidePrevented)
			}
		})
	},

	methods: {
		onCancel() {
			this.close(0, 'reject')
		},

		onConfirm() {
			this.close(this.$options.waitAfterClose, 'confirm')
		},

		// Close popup
		close(timeout, emit) {
			//console.log(`Close, emit=${emit}`)
			if (timeout > 0) {
				setTimeout(
					() => {
						this.$emit('update:show', false)
						this.$emit(emit)
					},
					timeout
				);
			} else{
				this.$emit('update:show', false)
				this.$emit(emit)
			}
		},
	},

	computed: {
		isConfirmButton() {
			return this.confirmButtonTitle.length > 0
		},

		isRejectButton() {
			return this.rejectButtonTitle.length > 0
		},
	},

	beforeUnmount() {
		if (this.modal) {
			if (this.handleHidePrevented) {
				// Remove event listener which created in mounted()
				this.$refs.modalRef.removeEventListener('hidePrevented.bs.modal',this.handleHidePrevented)
			}
			this.modal.dispose()
			this.modal = null
		}
	},
}
</script>




<style scoped>
.header-button {
	color: rgb(116, 116, 116);
	font-weight: 500;
	white-space: nowrap;
	margin-right: 4px;
}

.header-button:hover {
	color: inherit;
}
</style>